/* eslint-disable */
import r1 from './r1.js'

var r = function () {
  function o() {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, o),
      this.update = this.update.bind(this),
      this.views = {},
      this.watchers = {}
      // n(359)
  }
  return r1(o, [{
    key: "update",
    value: function (e) {
      for (var t, n = 0; n < e.length; n++)
        (t = this.views[e[n].target.dataset.intersectionId]) && t.update(e[n])
    }
  }], [{
    key: "start",
    value: function () {
      o.instance || (o.instance = new o)
    }
  }, {
    key: "bind",
    value: function (e, t) {
      var n = o.instance
        , i = n.watchers;
      if (n.views[e] = t) {
        var r = String(t.options.ratio);
        i[r] || (i[r] = new IntersectionObserver(n.update, {
          threshold: [t.options.ratio]
        })),
          i[r].observe(t.view)
      }
    }
  }, {
    key: "unbind",
    value: function (e, t) {
      var n = o.instance
        , i = n.watchers[String(t.options.ratio)];
      i && (delete n.views[e],
        t && i.unobserve(t.view))
    }
  }]),
    o
}();
var t = { default: r }

export default t
